<template>
  <div class="body">
    <header class="header">
      <div class="header__logo-contacts">
        <a href='https://ipnet.ua' target="_blank" class="header__logo">
          <img src="../../assets/logo.svg" alt="">
        </a>
        <span class="header__contacts">
          <div class="phone">
            <a href="tel:+380445070505">(044) 507 05 05</a>
          </div>
          <a href="https://ipnet.ua" class="site" target="_blank">
            ipnet.ua
          </a>
        </span>
      </div>
      <img v-if='$vuetify.breakpoint.smAndUp' class='header__bg' src="../../assets/20-years/header-lg-2.png">
      <img v-if='$vuetify.breakpoint.xs' class="header__bg" src="../../assets/20-years/header-sm.png">
    </header>
    <main class="main-block">
      <div class='main-block__left-stars-img'>
        <img v-if='$vuetify.breakpoint.smAndUp' src="../../assets/20-years/stars-left.png" alt="">
      </div>
      <div class="main-block__content block-shadow">
        <div class="tariff-cards">
          <CardItem :cardOptions="cardOption" v-for="(cardOption, index) of cardsOptions" :key="index"></CardItem>
        </div>
        <OrderForm :landingCodename="landingCodename" :gaFormTag="'20_years_order_middle'"></OrderForm>
      </div>
      <div class='main-block__right-stars-img'>
        <img v-if='$vuetify.breakpoint.smAndUp' src="../../assets/20-years/stars-right.png" alt="">
      </div>
    </main>
    <Advantages :advantagesOptions="advantagesOptions"></Advantages>
    <CoverMap :landingCodename="landingCodename" :gaFormTag="'20_years_order_bottom_map'"></CoverMap>
    <FooterSection></FooterSection>
    <SeoTextToggle :text="seoTextsToggle"></SeoTextToggle>
  </div>
</template>

<script>
import CardItem from '../../components/CardItem'
import Advantages from '../../components/Advantages.vue';
import CoverMap from '../../components/CoverMap';
import FooterSection from "../../components/FooterSection";
import OrderForm from '../../components/OrderForm';
import SeoTextToggle from '../../components/SeoTextToggle';
import cardOptions from './cardsOptions';
import seoTextsToggle from "./seoTexts";

export default {
  name: "TwentyYears",
  components: {
    CardItem,
    Advantages,
    CoverMap,
    FooterSection,
    OrderForm,
    SeoTextToggle
  },
  metaInfo: {
      title: 'Інтернет у Подарунок! 20 місяців за 20 грн/місяць домашнього інтернету з приводу 20-річчя IPnet ',
      titleTemplate: null,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: 'З приводу 20-річчя компанії IPNet пропонуємо отримати подарунок! ' +
                 '20 місяців надшвидкого доступу до інтернет всього за 20 грн на місяць.',
      }]
  },
  data() {
    this.landingCodename = 'twenty_years';
    this.cardsOptions = cardOptions;
    this.advantagesOptions = {
      title: 'ДОДАТКОВІ ПЕРЕВАГИ ВІД КОМПАНІЇ IPNET',
      options: [
        {
          text: 'ТЕХНІЧНА ПІДТРИМКА 24/7',
          icon: require('../../assets/20-years/icons/support.png')
        },
        {
          text: '20 РОКІВ УСПІХУ',
          icon: require('../../assets/20-years/icons/20-years.png')
        },
        {
          text: 'ВДОСКОНАЛЕНА МЕРЕЖА',
          icon: require('../../assets/20-years/icons/network.png')
        }
      ]
    }
    return {
      landingCodename: this.landingCodename,
      cardsOptions: this.cardsOptions,
      advantagesOptions: this.advantagesOptions,
      seoTextsToggle: seoTextsToggle,
    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.header__bg {
  width: 100%;
  height: auto;
}
.header__logo-contacts {
  position: absolute;
  left: 20%;
  top: 3%;
}
.header__logo img {
  width: 152px;
  height: 101px;
  filter: brightness(0) invert(1);
}
.header__contacts {
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
  .header__contacts a {
    text-decoration: none;
    color: #ffffff;
    font-weight: 800;
  }
  .header__contacts a:hover {
    text-decoration: underline;
  }
.main-block {
  position: relative;
  width: 100%;
  min-height: 700px;
  margin-top: -1px;
  padding: 0 25px 25px 25px;
  background-size: auto 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgb(227,32,102);
  /*background: linear-gradient(180deg, rgba(227,32,102,1) 0%, rgba(241,115,87,1) 50%, rgba(251,182,55,1) 100%);*/
  background: linear-gradient(180deg, rgba(227,32,102,1) 0%, rgb(0 79 232) 50%, rgb(219, 7, 80) 100%);
}

>>>.card__title {
  background-color: #004fe8;
}
.main-block__left-stars-img {
  position: absolute;
  left: 15%;
  top: 15%;
  transform: translate(-15%, -15%);
}
.main-block__right-stars-img {
  position: absolute;
  right: 15%;
  bottom: 10%;
}
.main-block__content {
  z-index: 2;
  background-color: #e9e9ea7a;
  border-radius: 25px;
  padding: 25px;
  display: flex;
  flex-direction: column;
}
.tariff-cards {
  display: flex;
  flex-direction: row;
  margin-bottom: 30px
}

>>>.additional-advantages, .footer {
  background-color: #db0050;
}

>>>.cover-dialog {
  background-color: #e9e9ea;
}

/* MEDIA QUERY */
@media (max-width: 950px) {
  .header__logo-contacts {
    left: 17%;
    top: 0;
  }
}
@media (max-width: 750px) {
  .header__logo-contacts {
    left: 15%;
    top: 0;
  }
}
@media (max-width: 800px) {
  .tariff-cards {
    flex-direction: column;
    margin-bottom: 0;
  }
}
@media (max-width: 600px) {
  .header__logo-contacts {
    flex-direction: row;
    width: 100%;
    left: 0;
    padding: 0 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .main-block__content {
    margin-top: 25px;
  }
}
@media (max-width: 400px) {
  .header__logo-contacts {
    padding: 0 25px;
  }
  .header__logo img {
    height: 90px;
  }
  .main-block__content {
    padding: 10px;
  }
}

</style>